import { validateInput } from "./BusinessAccountValidationService";
import { isFullFormValid } from "util/Validators";

export const businessAccountValidationInitialState = {
  accountTypeIdError: false,
  accountTypeIdErrMsg: '',
  numberError: false,
  numberErrMsg: "",
  addressError: false,
  addressErrMsg: "",
  cityError: false,
  cityErrMsg: "",
  stateError: false,
  stateErrMsg: "",
  zipError: false,
  zipErrMsg: "",
  countryError: false,
  countryErrMsg: "",
  emailError: false,
  emailErrMsg: '',
  firstNameError: false,
  firstNameErrMsg: '',
  lastNameError: false,
  lastNameErrMsg: '',
  mobilePhoneNumberError: false,
  mobilePhoneNumberErrMsg: '',
  recurringBillingError: false,
  recurringBillingErrMsg: '',
  recurringBillDomError: false,
  recurringBillDomErrMsg: '',
  recurringAmountError: false,
  recurringAmountErrMsg: '',
  billDueDaysError: false,
  billDueDaysErrMsg: false,
  // verificationPinError: false,
  // verificationPinErrMsg: "",

  isFormValid: true
}

export const BusinessAccountFormValidationReducer = (currentState, action) => {
  if (!action.payload) {
    return currentState;
  }
  let isValid = false;
  switch (action.type) {
    case 'VALIDATE_ACCOUNTTYPEID':
      let { accountTypeId } = action.payload;
      let accountTypeIdState = validateInput('accountTypeId', accountTypeId);
      isValid = !accountTypeIdState.hasError;
      let accountTypeIdErrMsg = accountTypeIdState.error;

      // isValid = (number.length > 0) ? true : false;
      // let numberErrMsg = "Account Number cannot be blank";
      return {
        ...currentState,
        ...({ accountTypeIdError: !isValid, accountTypeIdErrMsg: accountTypeIdErrMsg, isFormValid: isFullFormValid(currentState, 'accountTypeIdError', !isValid) })
      }

    case "VALIDATE_ADDRESS":
      let { address } = action.payload;
      let addressState = validateInput('address', address);
      isValid = !addressState.hasError;
      let addressErrMsg = addressState.error;
      return {
        ...currentState,
        ...({ addressError: !isValid, addressErrMsg: addressErrMsg, isFormValid: isFullFormValid(currentState, 'addressError ', !isValid) })
      }
    case "VALIDATE_CITY":
      let { city } = action.payload;
      let cityState = validateInput('city', city);
      isValid = !cityState.hasError;
      let cityErrMsg = cityState.error;
      return {
        ...currentState,
        ...({ cityError: !isValid, cityErrMsg: cityErrMsg, isFormValid: isFullFormValid(currentState, 'cityError ', !isValid) })
      }

    case "VALIDATE_STATE":
      let { state } = action.payload;
      let provinceState = validateInput('state', state);
      isValid = !provinceState.hasError;
      let provinceErrMsg = provinceState.error;
      return {
        ...currentState,
        ...({ stateError: !isValid, stateErrMsg: provinceErrMsg, isFormValid: isFullFormValid(currentState, 'stateError ', !isValid) })
      }
    case "VALIDATE_ZIP":
      let { zip, formData } = action.payload;
      let zipState = validateInput('zip', zip, formData);
      isValid = !zipState.hasError;
      let zipErrMsg = zipState.error;

      // isValid = (zip.length > 0) ? true : false;
      // let zipErrMsg = "Zip cannot be blank";
      return {
        ...currentState,
        ...({ zipError: !isValid, zipErrMsg: zipErrMsg, isFormValid: isFullFormValid(currentState, 'zipError', !isValid) })
      }
    case "VALIDATE_COUNTRY":
      let { country } = action.payload;
      let countryValidationState = validateInput('country', country);
      isValid = !countryValidationState.hasError;
      let countryErrMsg = countryValidationState.error;
      return {
        ...currentState,
        ...({ countryError: !isValid, countryErrMsg: countryErrMsg, isFormValid: isFullFormValid(currentState, 'countryError', !isValid) })
      }

    case "VALIDATE_FIRSTNAME":
      let { firstName } = action.payload;
      let firstNameValidationState = validateInput('firstName', firstName);
      isValid = !firstNameValidationState.hasError;
      let firstNameErrMsg = firstNameValidationState.error;
      return {
        ...currentState,
        ...({ firstNameError: !isValid, firstNameErrMsg: firstNameErrMsg, isFormValid: isFullFormValid(currentState, 'firstNameError', !isValid) })
      };
    case "VALIDATE_LASTNAME":
      let { lastName } = action.payload;
      let lastNameValidationState = validateInput('lastName', lastName);
      isValid = !lastNameValidationState.hasError;
      let lastNameErrMsg = lastNameValidationState.error;
      return {
        ...currentState,
        ...({ lastNameError: !isValid, lastNameErrMsg: lastNameErrMsg, isFormValid: isFullFormValid(currentState, 'lastNameError', !isValid) })
      };
    case "VALIDATE_COMPANYNAME":
        let { companyName } = action.payload;
        let companyNameValidationState = validateInput('companyName', companyName);
        isValid = !companyNameValidationState.hasError;
        let companyNameErrMsg = companyNameValidationState.error;
        return {
          ...currentState,
          ...({ companyNameError: !isValid, companyNameErrMsg: companyNameErrMsg, isFormValid: isFullFormValid(currentState, 'companyNameError', !isValid) })
        };      
    case "VALIDATE_MOBILEPHONENUMBER":
      let { mobilePhoneNumber } = action.payload;
      let mobilePhoneNumberValidationState = validateInput('mobilePhoneNumber', mobilePhoneNumber);
      isValid = !mobilePhoneNumberValidationState.hasError;
      let mobilePhoneNumberErrMsg = mobilePhoneNumberValidationState.error;
      return {
        ...currentState,
        ...({ mobilePhoneNumberError: !isValid, mobilePhoneNumberErrMsg: mobilePhoneNumberErrMsg, isFormValid: isFullFormValid(currentState, 'mobilePhoneNumberError', !isValid) })
      };

    case "VALIDATE_EMAIL":
      let { email } = action.payload;
      let emailValidationState = validateInput('email', email);
      isValid = !emailValidationState.hasError;
      let emailErrMsg = emailValidationState.error;
      return {
        ...currentState,
        ...({ emailError: !isValid, emailErrMsg: emailErrMsg, isFormValid: isFullFormValid(currentState, 'emailError', !isValid) })
      }

    case "VALIDATE_RECURRINGBILLING":
      let { recurringBilling } = action.payload;
      let recurringBillingValidationState = validateInput('recurringBilling', recurringBilling);
      isValid = !recurringBillingValidationState.hasError;
      let recurringBillingErrMsg = recurringBillingValidationState.error;
      return {
        ...currentState,
        ...({ recurringBillingError: !isValid, recurringBillingErrMsg: recurringBillingErrMsg, isFormValid: isFullFormValid(currentState, 'recurringBillingError', !isValid) })
      }

    case "VALIDATE_RECURRINGBILLDOM":
      let { recurringBillDom } = action.payload;
      if (!recurringBillDom) {
        return {
          ...currentState
        }
      }
      let recurringBillDomValidationState = validateInput('recurringBillDom', recurringBillDom);
      isValid = !recurringBillDomValidationState.hasError;
      let recurringBillDomErrMsg = recurringBillDomValidationState.error;
      return {
        ...currentState,
        ...({ recurringBillDomError: !isValid, recurringBillDomErrMsg: recurringBillDomErrMsg, isFormValid: isFullFormValid(currentState, 'recurringBillDomError', !isValid) })
      }

    case "VALIDATE_RECURRINGAMOUNT":
      let { recurringAmount } = action.payload;
      if (!recurringAmount) {
        return {
          ...currentState
        }
      }
      let recurringAmountValidationState = validateInput('recurringAmount', recurringAmount);
      isValid = !recurringAmountValidationState.hasError;
      let recurringAmountErrMsg = recurringAmountValidationState.error;
      return {
        ...currentState,
        ...({ recurringAmountError: !isValid, recurringAmountErrMsg: recurringAmountErrMsg, isFormValid: isFullFormValid(currentState, 'recurringAmountError', !isValid) })
      }

      case "VALIDATE_BILLDUEDAYS":
        let { billDueDays } = action.payload;
        if (!billDueDays) {
          return {
            ...currentState
          }
        }
        let billDueDaysValidationState = validateInput('billDueDays', billDueDays);
        isValid = !billDueDaysValidationState.hasError;
        let billDueDaysErrMsg = billDueDaysValidationState.error;
        return {
          ...currentState,
          ...({ billDueDaysError: !isValid, billDueDaysErrMsg: billDueDaysErrMsg, isFormValid: isFullFormValid(currentState, 'billDueDaysError', !isValid) })
        }      


    default:
      return currentState
  }
}



